module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAANCAYAAABPeYUaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADwSURBVHgBpZKNDYJADIV7xgEcgQ3ECYQJxAnESWQEncA4AWwAbgAToBPgBvhe6EkggH9Nvlyu19e7tmdkwuq69rC4YAEyY0w2FGdGxBTFKr6qewNysEeyx2ASFQbAAUtQIDjqJT/yDH5/6GYXlCAFETjLeImlxjidp+tBKB8Y4gK+SDUH6wxBMiHytMF9vwMqVjGTpge5jJundAx9uWG58IxJuFnLH8YkLIVP230j1MZy7MmcM4dji03MpmEtRD+Wjv0lYgnaH4pDcKJvLk19OQ5X0v4Te1Mqbb9SjaHdgU/duxfb/1PZKcivpokmEzwBN0eovHCbqlYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/download.png
// module id = NZ1t
// module chunks = 36